<template>
  <div class="page kone">
    <Residence v-if="isResidence" section="residence"/>
    <Profession v-if="isProfession" section="profession"/>
    <Values v-if="isValues" section="values"/>
    <Hobbies v-if="isHobbies" section="hobbies"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Residence from '../components/Residence'
import Profession from '../components/Profession'
import Values from '../components/Values'
import Hobbies from '../components/Hobbies'

export default {
  name: 'kone',
  components: { Residence, Profession, Values, Hobbies },
  computed: {
    ...mapGetters(['isResidence', 'isProfession', 'isValues', 'isHobbies', 'isResult'])
  }
}
</script>
